/**
 * default session type when open the session type creator
 */
export const DEFAULT_SESSION_TYPE: Partial<SessionType> = Object.freeze({
  label: "",
  only_followup: false,
  padding_min: 5,
  align_min: 30,
  enabled: true,
});
